// extracted by mini-css-extract-plugin
export var button = "_dx-0";
export var icon = "_dx-1";